import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g data-name="Group 1416">
          <g data-name="Group 1410">
            <g
              fill="none"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              data-name="Group 1404"
            >
              <circle cx="75" cy="55" r="20.05" data-name="Ellipse 20" />
              <path
                d="M70 64.22h5.16a4.44 4.44 0 004.45-4.44h0a4.44 4.44 0 00-4.45-4.44h-.72A4.44 4.44 0 0170 50.9h0a4.44 4.44 0 014.44-4.45h5.17"
                data-name="Path 1186"
              />
              <path d="M75 46.45v-3.28" data-name="Line 94" />
              <path d="M75 64.22v3.28" data-name="Line 95" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
